module.exports = __webpack_public_path__ + "files/d5ac385954ba5a8589f1d23b1ff62f91.png";